import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';
import { Edit } from '@material-ui/icons';

import { getDuplicatedTransactions } from '../../services/payment';

const DuplicatedTransactions = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();

  const [duplicatedTransactions, setDuplicatedTransactions] = useState([]);
  const [actualPage, setActualPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let page = params.page || actualPage;
    displayDuplicatedTransactions(page);
  }, []);

  const displayDuplicatedTransactions = async (page = 0) => {
    try {
      setIsLoading(true);
      if (!page) page = actualPage;
      const { data } = await getDuplicatedTransactions(page);
      if (data.length) {
        setDuplicatedTransactions(data);
        setTotalItems(data.length);
        setTotalPages(data.pages);
      } else {
        setDuplicatedTransactions([]);
        setTotalItems(0);
        setTotalPages(0);
      }
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const headers = ['count', 'paymentToken', 'transactionIdInOrigin'];
  const customActions = [
    {
      action: async row => {
        try {
          history.push(`/transactions/duplicated/${row.transactionIdInOrigin}/${row.paymentToken}`);
        } catch (error) {
          console.log(error);
        }
      },
      icon: <Edit />,
    },
  ];

  const handleChangePage = async page => {
    setActualPage(page);
    displayDuplicatedTransactions(page);
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Duplicated Transactions Count ({totalItems})</h1>
      </div>

      <DataTable
        useUid
        head={headers}
        body={duplicatedTransactions}
        bodyColumn={headers}
        customActions={customActions}
        linkPath="transactions"
        totalPages={totalPages}
        currentPage={actualPage}
        setPageChange={handleChangePage}
        isNotOrdenable
      />
    </>
  );
};

export default DuplicatedTransactions;
